import React, { useState, useEffect } from 'react';
import api from '../../api/axios';

const DatasetSelector = ({ projectId, apiPrefix, onDatasetLoaded, buttonText = "Load Dataset" }) => {
  const [datasets, setDatasets] = useState([]);
  const [selectedDataset, setSelectedDataset] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (projectId) {
      fetchDatasets();
    } else {
      setDatasets([]);
    }
  }, [projectId]);

  const fetchDatasets = async () => {
    try {
      const res = await api.get(`/api/v1/tables/project/${projectId}/datasets`);
      const datasets = res.data.map(ds => ({
        id: ds.id,
        name: ds.original_filename,
        rows: ds.row_count,
        columns: ds.column_count,
        size_mb: (ds.file_size / 1e6).toFixed(2)
      }));
      setDatasets(datasets);
    } catch (error) {
      console.error('Failed to load datasets:', error);
    }
  };

  const handleLoadDataset = async () => {
    if (!selectedDataset || !apiPrefix) return;
    setLoading(true);
    try {
      const res = await api.post(`${apiPrefix}/select-dataset`, {
        dataset_id: parseInt(selectedDataset)
      });
      onDatasetLoaded(res.data);
    } catch (error) {
      console.error('Failed to load dataset:', error);
    } finally {
      setLoading(false);
    }
  };

  const formatRows = (rows) => {
    if (!rows || rows === '?') return '';
    if (rows > 1000000) return `${(rows / 1000000).toFixed(1)}M`;
    if (rows > 1000) return `${(rows / 1000).toFixed(0)}K`;
    return rows;
  };

  return (
    <div style={{ display: 'flex', gap: '12px', marginBottom: '24px' }}>
      <select 
        value={selectedDataset} 
        onChange={(e) => setSelectedDataset(e.target.value)}
        disabled={loading}
        style={{ flex: 1, padding: '12px', borderRadius: '8px', border: '1px solid #ddd' }}
      >
        <option value="">-- Select a dataset --</option>
        {datasets.map(ds => (
          <option key={ds.id} value={ds.id}>
            {ds.name} ({formatRows(ds.rows)} rows)
          </option>
        ))}
      </select>
      <button 
        onClick={handleLoadDataset} 
        disabled={!selectedDataset || loading || !apiPrefix}
        style={{ padding: '12px 24px', background: '#3498db', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer' }}
      >
        {loading ? 'Loading...' : buttonText}
      </button>
    </div>
  );
};

export default DatasetSelector;
